import { createContext, useContext } from 'react'
import type { Locale, MessageKey, MessageVars } from './messages'

export interface I18nValue {
  locale: Locale
  setLocale: (l: Locale) => void
  toggleLocale: () => void
  /** Message in the current language. */
  t: (key: MessageKey, vars?: MessageVars) => string
  /** The same message in both languages — for BilingualLabel on phone screens. */
  pair: (key: MessageKey, vars?: MessageVars) => { hi: string; en: string }
}

export const I18nContext = createContext<I18nValue | null>(null)

export function useI18n(): I18nValue {
  const ctx = useContext(I18nContext)
  if (!ctx) throw new Error('useI18n must be used inside <I18nProvider>')
  return ctx
}
